import { RootErrorBoundary } from "./RootErrorBoundary.tsx";
import { RootLayout } from "./RootLayout.tsx";

export interface AppRouterErrorBoundaryProps {
    error?: unknown;
}

export function AppRouterErrorBoundary({ error }: AppRouterErrorBoundaryProps) {
    return (
        <RootLayout>
            <RootErrorBoundary error={error} />
        </RootLayout>
    );
}
